<template>
  <div class="post__pet px-3 pt-4">
    <div class="d-flex flex-column justify-content-center">

        <div class="post__pet-avatar d-flex justify-content-center">
            <a :href="profile" class="rounded-circle overflow-hidden mb-3">
                <img :src="avatar" alt="">
            </a>
        </div>

        <a class="post__pet-title mb-3" :href="profile">{{ pet.name }}</a>

        <div class="d-flex justify-content-center align-items-center post__pet-info mb-3">
            <span v-text="createdAt"></span>
            <span class="blue">id: {{ pet.id }}</span>
        </div>

        <div class="post__pet-meta d-flex flex-wrap justify-content-center mb-1">
            <span v-text="gender"></span><span v-text="age"></span><span v-text="weight"></span>
        </div>

        <div class="post__pet-meta d-flex justify-content-center">
            <span>Размер: {{ size }} </span>
        </div>

        <div class="post__pet-actions d-flex justify-content-center flex-wrap">
            <a class="btn btn-light" :href="profile">Профиль</a>
            <a class="btn" :href="profile">Помочь!</a>
        </div>

    </div>
  </div>
</template>

<script>
import { sizes, weight } from '../../../constants/pet-meta.js'

export default {
    name: "PostPet",
    props: {
        pet: { required: true, type: Object }
    },

    computed:{
        weight(){
            return weight[this.pet.weight]  ?? '0кг'
        },
        size(){
            return sizes[this.pet.size] ?? 'Неизвестно'
        },
        age(){
            return this.pet.petAgeCategory.name
        },
        gender(){
            return this.pet.gender === 'female' ? 'Девочка' : "Мальчик"
        },
        createdAt(){
            return ((this.pet.created_at.split('T'))[0]).split('-').reverse().join('.')
        },
        avatar(){
            let { path } = this.pet.avatar
            return `/storage/${path.replace('original', 'avatar')}`
        },
        profile(){
            const { id }  = this.pet    
            return `/pets/${id}/`
        },
    }

}
</script>